export default __webpack_public_path__ + "static/media/x-cross-red.349b3aac.svg";